function initReviews1(section) {
  if (!section) return;

  const track = section.querySelector('.reviews-1-track');
  const slides = section.querySelectorAll('.reviews-1-slide');
  const prev = section.querySelector('.reviews-1-arrow-left');
  const next = section.querySelector('.reviews-1-arrow-right');
  const dotsBox = section.querySelector('.reviews-1-dots');

  if (!track || slides.length === 0) return;

  let index = 0;

  const modal = section.querySelector('.reviews-1-modal');
  const modalOverlay = section.querySelector('.reviews-1-modal__overlay');
  const modalClose = section.querySelector('.reviews-1-modal__close');
  const modalIframe = section.querySelector('.reviews-1-modal__video iframe');

  function openModal(vid) {
    if (!modal || !modalIframe || !vid) return;
    modalIframe.src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (modalClose) modalClose.focus();
  }

  function closeModal() {
    if (!modal || !modalIframe) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modalIframe.src = '';
    document.body.style.overflow = '';
  }

  section.querySelectorAll('.reviews-1-video').forEach((vw) => {
    vw.addEventListener('click', () => {
      const vid = vw.getAttribute('data-vid');
      openModal(vid);
    });
  });

  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  function isMobile() {
    return window.innerWidth < 768;
  }

  function perView() {
    return isMobile() ? 1 : 3;
  }

  function maxIndex() {
    return Math.max(slides.length - perView(), 0);
  }

  function update() {
    const slideWidth = slides[0].offsetWidth;
    track.style.transform = 'translateX(-' + (index * slideWidth) + 'px)';
    updateDots();
    updateArrowStates();
  }

  function updateArrowStates() {
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= maxIndex();
  }

  if (prev) {
    prev.onclick = () => {
      index = Math.max(index - 1, 0);
      update();
    };
  }

  if (next) {
    next.onclick = () => {
      index = Math.min(index + 1, maxIndex());
      update();
    };
  }

  function setupDots() {
    if (!dotsBox) return;
    dotsBox.innerHTML = '';
    if (!isMobile()) return;

    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.onclick = () => {
        index = i;
        update();
      };
      dotsBox.appendChild(b);
    });
  }

  function updateDots() {
    if (!dotsBox) return;
    const dots = dotsBox.querySelectorAll('button');
    dots.forEach((d, i) => d.classList.toggle('active', i === index));
  }

  setupDots();
  update();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      index = 0;
      setupDots();
      update();
    }, 150);
  });
}

document.querySelectorAll('.reviews-1-section').forEach(initReviews1);

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.reviews-1-section');
  if (section) initReviews1(section);
});
